import { ComponentProps, ReactElement } from 'react';

import { getClasses } from '@/utils';

export type SkyhopPdfFooterSectionProps = ComponentProps<'ul'>;

const SkyhopPdfFooterSection = ({ ...props }: SkyhopPdfFooterSectionProps): ReactElement => (
  <ul {...props} className={getClasses('SkyhopPdfFooter-Section', props.className)} />
);

export default SkyhopPdfFooterSection;
